import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetMasterMission {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const getMasterMission = ({
  search = '',
  page,
  size,
  scheduleid = '',
  userin = ''
}: GetMasterMission) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.mission.getList
    }?search=${search}&page=${page}&userin=${userin || ''}&take=10000`
  );
};

export const getMasterMissionById = (id: string) => {
  return HttpService.get(`${ApiService.icdc.module.mission.detail}?id=${id}`);
};

export const getBusinessUnit = () => {
  return HttpService.post(ApiService.icdc.module.bisnisUnit.getList, {});
};

export const postMasterMission = (data) => {
  return HttpService.post(ApiService.icdc.module.mission.add, data);
};

export const editMasterMission = (data) => {
  return HttpService.post(ApiService.icdc.module.mission.update, data);
};

export const deleteMasterMission = (data) => {
  return HttpService.post(ApiService.icdc.module.mission.delete, data);
};
